export type SelectableDoodleTool = 'brush' | 'eraser';
export type DoodleTranslate = (key: string, options?: Record<string, string>) => string;

export const DOODLE_COLORS = [
	{ hex: '#14151A', name: 'black' },
	{ hex: '#F04747', name: 'red' },
	{ hex: '#FF8B1B', name: 'orange' },
	{ hex: '#FCC84F', name: 'yellow' },
	{ hex: '#4BB475', name: 'green' },
	{ hex: '#9D8DF1', name: 'purple' },
	{ hex: '#2981E6', name: 'blue' },
] as const;

export const DOODLE_SIZES = [
	{ value: 1, name: 'extra_small' },
	{ value: 2, name: 'small' },
	{ value: 4, name: 'medium' },
	{ value: 8, name: 'large' },
] as const;

// Eraser tiers mirror the brush sizes so equivalent tiers stay aligned. The
// eraser renders slightly broader via its larger scale in each stroke renderer.
export const DOODLE_ERASER_SIZES = [
	{ value: 1, dot: 6, name: 'small' },
	{ value: 2, dot: 9, name: 'medium' },
	{ value: 4, dot: 14, name: 'large' },
	{ value: 8, dot: 20, name: 'extra_large' },
] as const;
